<template>
  <div class="hello">
    <header class="bs_header">
      <div><span class="company_name">博文商学文化发展有限公司</span></div>
      <ul class="bs_header_list">
        <li>
          <a href="javascript:void(0);">首页</a>
        </li>
        <li>
          <a @click="moveToResolve" href="javascript:void(0);">企业家实战班</a>
        </li>
        <li>
          <a @click="moveToTeacher" href="javascript:void(0);">博商介绍</a>
        </li>
        <li>
          <img class="bs_mobile" src="../assets/images/bs_mobile.png" alt="">
        </li>
      </ul>
    </header>
    <div>
      <img src="../assets/images/bs_content1.png" class="img" alt="">
    </div>
    <div>
      <img src="../assets/images/bs_content2.png" class="img" alt="">
    </div>
    <div id="bs_resolve">
      <img src="../assets/images/bs_content3.png" class="img" alt="">
    </div>
    <div id="bs_teacher">
      <img src="../assets/images/bs_content4.png" class="img" alt="">
    </div>
    <div>
      <img src="../assets/images/bs_content5.png" class="img" alt="">
    </div>
    <footer>
      <div class="bs_footer_outer">
        <div class="bs_logo_footer">
          <div class="bs_footer_inner">
            <p><span>咨询电话：</span><br><b>135-3817-5625</b></p>
            <p><span>深圳市博文商学文化发展有限公司</span></p>
            <p><span>深圳市前海深港合作区南山街道兴海大道3044<br/>信利康大厦16B</span></p>
          </div>
          <img src="../assets/images/bs_logo_footer.png" alt="">
        </div>
      </div>
      <!--备案信息-->
      <div class="xd-record">
        <a href="http://beian.miit.gov.cn" target="_blank">粤ICP备2021044895号</a>
        <span>@版权所有： 深圳市博商管理咨询有限公司 </span>
      </div>
    </footer>

  </div>
</template>

<script>
  import $ from 'jquery';

  export default {
    name: 'Index',
    data() {
      return {}
    },
    methods: {
      moveToDiv: function (elem) {
        var h = elem.offset().top;
        $('body,html').animate({scrollTop: h}, 300);
      },
      moveToResolve: function () {
        var vm = this;
        var elem = $('#bs_resolve');
        vm.moveToDiv(elem);
      },
      moveToTeacher: function () {
        var vm = this;
        var elem = $('#bs_teacher');
        vm.moveToDiv(elem);
      },
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/index.vue